import { FormCellTW } from '../../../tailwindComponents/formCellTW/FormCellTW';
import React, { Fragment } from 'react';
import { eWeekdays, prettyWeekDays } from '../../../types/userProfile/IUserProfile';
import { BoldBodyText, Grid, TimeField } from '../../../ui-toolkit';

export const WorkScheduleFields: React.FC = () => {
  return (
    <FormCellTW labelText={'Work Schedule'}>
      <Grid templateColumns="min-content 1fr" alignItems="center">
        {Object.values(eWeekdays).map((day) => (
          <Fragment key={day}>
            <BoldBodyText>{prettyWeekDays[day]}</BoldBodyText>
            <Grid templateColumns="1fr min-content 1fr" alignItems="center">
              <TimeField name={`workSchedule.${day}.startTime`} allowInvalidValues={true} />
              <span className="mx-2">to</span>
              <TimeField name={`workSchedule.${day}.endTime`} allowInvalidValues={true} />
            </Grid>
          </Fragment>
        ))}
      </Grid>
    </FormCellTW>
  );
};
